
import Icon from '@material-ui/icons/PhonelinkSetup';
import List from './InstrumentList'
import Create from './InstrumentCreate'
import Edit from './InstrumentEdit'
import Show from './InstrumentView'


export default {
    list: List,
    icon: Icon,
    create: Create,
    edit: Edit,
    show: Show
};

